import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const ErrorIcon = styled(FontAwesomeIcon).attrs({
  icon: faExclamationCircle,
})``;

export default ErrorIcon;
